export const isClipboardEnabled = () =>
  Boolean(navigator?.clipboard?.writeText) && window.isSecureContext;
